import { IonApp, IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';
import Menu from './components/Menu';

import Clients from './pages/Clients';
import Lessor from './pages/Lessor';
import Property from './pages/Property';
import Amenities from './pages/Amenities';
import Reports from './pages/Reports';
import Listings from './pages/Listings';
import Notifications from './pages/Notifications';
import Accounts from './pages/Accounts';
import MasterData from './pages/MasterData';
import ViewClient from './pages/ViewClient';
import PropertyDetails from './pages/PropertyDetails';
import LessorDetails from './pages/LessorDetails';
import NewAmenities from './pages/NewAmenities';
import Register from './pages/Register';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Inquiries from './pages/Inquiries';
import AdminSettings from './pages/AdminSettings';
import ForgotPassword from './pages/ForgotPassword';
import Room from './pages/Room';
import RoomDetails from './pages/RoomDetails';
import InquiryDetails from './pages/InquiryDetails';
import Equipment from './pages/Equipment';
import Tenants from './pages/Tenants';
import Users from './pages/Users';
import ListingsDetails from './pages/ListingsDetails';
import { checklogin, setlogin } from "./store/actions";
import { UIStore } from "./store/store";
import NewEquipment from "./pages/NewEquipment";
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';




const Loginroutes: React.FC = (props) => {
  return (
    <IonApp>
      <IonReactRouter>
        <Route path="/" exact={true}>
              <Redirect to="/Login" />
        </Route>

        <Route path="/Login" exact={true}  component={Login}/>
        <Route path="/Register" exact={true} component={Register} />


        <Route path="/ForgotPassword" exact={true} component={ForgotPassword} />

      </IonReactRouter>
    </IonApp>
  );
};


const Internalroutes: React.FC = (props) => {


  return (
    <IonApp>
      <IonReactRouter >
        <IonSplitPane contentId="main">
          <Menu />

          <IonRouterOutlet id="main">

            <Route path="/" exact={true}>
              <Redirect to="/Tenants" />
            </Route>

            <Route path="/Clients" exact={true} component={Clients} />

            <Route path="/Lessor" exact={true} component={Lessor} />

            <Route path="/Property" exact={true} component={Property} />

            <Route path="/Notifications" exact={true} component={Notifications} />

            <Route path="/Reports" exact={true} component={Reports} />

            <Route path="/Accounts" exact={true} component={Accounts} />

            <Route path="/Inquiries" exact={true} component={Inquiries} />

            <Route path="/NewAmenities" exact={true} component={Amenities} />

            <Route path="/MasterData" exact={true} component={MasterData} />

            <Route path="/AdminSettings" exact={true} component={AdminSettings} />

            <Route path="/Listings" exact={true} component={Listings} />
            <Route path="/ListingsDetails" exact={true} component={ListingsDetails} />

            <Route path="/Equipment" exact={true} component={Equipment} />

            <Route path="/NewAmenities" exact={true} component={NewAmenities} />
            <Route path="/NewEquipment" exact={true} component={NewEquipment} />


            <Route path="/Tenants" exact={true} component={Tenants} />
            <Route path="/Users" exact={true} component={Users} />

            <Route path="/Room" exact={true} component={Room} />
            <Route path="/RoomDetails" exact={true} component={RoomDetails} />

            <Route path="/InquiryDetails" exact={true} component={InquiryDetails} />
            <Route path="/ViewClient" exact={true} component={ViewClient}>
            </Route>
            <Route path="/PropertyDetails" exact={true} component={PropertyDetails}>
            </Route>
            <Route path="/LessorDetails" exact={true} component={LessorDetails}>
            </Route>
            <Route path="/Amenities" exact={true} component={Amenities}>
            </Route>


            <Route path="/Admin" exact={true} component={Admin}>
            </Route>

          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
    </IonApp>
  );
};



const App: React.FC = (props: any) => {
  let loginstate = UIStore.useState((s: { isLoggedIn: any; }) => s.isLoggedIn);

  return (


    <IonApp>
      <IonReactRouter >

        <IonRouterOutlet id="main">
          {/* <Route path="/RegistrationPage" component={Register} />
      <Route path="/LoginPage" exact={true} component={Login} />
      <Route path="/ForgotPassword" exact={true} component={ForgotPassword} /> */}
          {/* <Route
            exact
            path="/"
            render={props => {


              console.log(loginstate);

              return checklogin() ? < Internalroutes /> : <   Loginroutes />;
            }}
          /> */}
          
       {checklogin() ? < Internalroutes />: <Loginroutes />}


        </IonRouterOutlet>

      </IonReactRouter>
    </IonApp>




  );
};

export default App;
